import { combineReducers } from "redux";
import Authentication from "./Authentication";
import UIReducer from "./ui";

const rooReducer = combineReducers({
	data: Authentication,
	ui: UIReducer,
});
export default rooReducer;
